module.exports = __webpack_public_path__ + "img/6.c4c9b85a.jpg";